module.exports = __webpack_public_path__ + "static/media/LOMCURRY_MENU-normal.89f9f3d0.png";